/**
 * Utility functions for handling assets.
 */

/**
 * Constructs the full URL for an asset stored in the S3 bucket.
 *
 * @param key The S3 key of the asset.
 * @returns The full URL to the asset, or an empty string if the bucket name is not configured.
 */
export const getAssetUrl = (key: string): string => {
  const bucketName = process.env.NEXT_PUBLIC_IMAGE_BUCKET_NAME!;
  const cleanKey = key.startsWith('/') ? key.substring(1) : key;
  return `https://${bucketName}/${cleanKey}`;
};
